import { CellContext } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { FolderPermissionResponse } from '../../../../api/types.gen';
import { ReadPermissionLevel } from './PermissionEnums';
import { PermissionTableFeatures } from './permissionTableFeatures';

interface ReadPermissionCellProps {
  cellContext: CellContext<PermissionTableFeatures, FolderPermissionResponse, ReadPermissionLevel>;
}

export function ReadPermissionCell({ cellContext }: ReadPermissionCellProps) {
  const { t } = useTranslation('', { keyPrefix: 'permissions' });
  const value = cellContext.getValue();

  switch (value) {
    case ReadPermissionLevel.FullDetails:
      return <>{t('readPermissionsFull')}</>;
    default:
      return <>{t('readPermissionsNone')}</>;
  }
}
